var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1865 4785 c-250 -55 -456 -239 -554 -494 -80 -208 -85 -455 -12 -664 44 -128 101 -217 201 -317 104 -104 170 -148 282 -187 96 -34 261 -42 360 -19 288 67 510 310 585 639 26 117 22 318 -10 439 -110 418 -486 684 -852 603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3504 4391 c-296 -47 -548 -292 -635 -616 -30 -111 -30 -307 -1 -416 85 -315 327 -512 626 -510 314 1 588 222 707 569 33 95 34 101 33 262 0 151 -2 172 -26 242 -75 223 -242 392 -447 452 -66 19 -189 27 -257 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 3795 c-369 -90 -563 -517 -417 -919 83 -230 265 -409 484 -478 98 -31 251 -31 352 0 145 45 276 158 349 303 58 116 77 213 72 359 -4 106 -10 139 -37 219 -46 137 -99 222 -205 326 -73 73 -108 99 -177 133 -138 68 -289 89 -421 57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4385 3074 c-38 -8 -116 -37 -171 -64 -265 -128 -444 -411 -444 -700 0 -188 56 -328 179 -450 128 -128 258 -176 446 -167 124 6 211 31 324 93 87 49 234 196 289 289 129 220 145 483 43 690 -50 100 -101 159 -188 219 -135 92 -315 126 -478 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164 2961 c-218 -39 -408 -125 -579 -264 -134 -109 -203 -202 -527 -707 -171 -267 -324 -512 -339 -545 -94 -201 -94 -460 1 -662 102 -218 292 -374 530 -434 71 -18 104 -21 215 -17 113 4 141 9 215 35 385 139 426 148 695 147 168 0 216 -3 302 -22 98 -21 137 -34 373 -118 95 -34 117 -38 230 -42 180 -6 303 24 448 109 80 48 210 180 262 267 70 119 101 225 107 367 6 138 -9 235 -55 344 -26 60 -464 757 -633 1006 -61 90 -182 222 -264 288 -260 211 -643 307 -981 248z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetsIcon);
export default __webpack_public_path__ + "static/media/pets_icon.7c35f93c19775133be12098d755fa973.svg";
export { ForwardRef as ReactComponent };